import { render } from "./DModal.vue?vue&type=template&id=c69a07e4&scoped=true"
import script from "./DModal.vue?vue&type=script&lang=js"
export * from "./DModal.vue?vue&type=script&lang=js"

import "./DModal.vue?vue&type=style&index=0&id=c69a07e4&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69a07e4"]])

export default __exports__